<template>
  <div :class="['v2-field', { 'v2-field--has-error': error }]">
    <label v-if="label" :for="selectId" class="v2-field__label">
      {{ label }}
      <span v-if="required" class="v2-field__required" aria-hidden="true">*</span>
    </label>
    <select
      :id="selectId"
      :value="value"
      :disabled="disabled"
      :required="required"
      :aria-invalid="Boolean(error)"
      class="v2-input v2-select"
      :class="{ 'v2-input--error': error }"
      @change="onChange"
      @blur="$emit('blur', $event)"
      @focus="$emit('focus', $event)"
    >
      <option v-if="placeholder" value="" disabled>{{ placeholder }}</option>
      <option
        v-for="opt in normalizedOptions"
        :key="String(opt.value)"
        :value="opt.value"
        :disabled="opt.disabled"
      >
        {{ opt.label }}
      </option>
    </select>
    <p v-if="helper && !error" class="v2-field__helper">{{ helper }}</p>
    <p v-if="error" class="v2-field__error" role="alert">{{ error }}</p>
  </div>
</template>

<script>
let counter = 0;
export default {
  name: "BaseSelect",
  props: {
    value: { type: [String, Number, Boolean, Object], default: "" },
    label: { type: String, default: "" },
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: { type: String, default: "" },
    helper: { type: String, default: "" },
    error: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    id: { type: String, default: "" },
  },
  data() {
    counter += 1;
    return { autoId: `v2-select-${counter}` };
  },
  computed: {
    selectId() {
      return this.id || this.autoId;
    },
    normalizedOptions() {
      return this.options.map((o) => {
        if (o === null || o === undefined) return { value: "", label: "", disabled: false };
        if (typeof o === "object") {
          return {
            value: o.value,
            label: o.label !== undefined ? o.label : String(o.value),
            disabled: Boolean(o.disabled),
          };
        }
        return { value: o, label: String(o), disabled: false };
      });
    },
  },
  methods: {
    onChange(e) {
      this.$emit("input", e.target.value);
      this.$emit("change", e.target.value);
    },
  },
};
</script>

<style scoped>
.v2-field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.v2-field__label {
  font-family: var(--font-body);
  font-size: var(--fs-label-md);
  font-weight: var(--fw-medium);
  color: var(--color-text);
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
}

.v2-field__required { color: var(--color-error); }

.v2-field__helper {
  font-size: var(--fs-caption);
  color: var(--color-text-muted);
  margin: 0;
}

.v2-field__error {
  font-size: var(--fs-caption);
  color: var(--color-error);
  margin: 0;
}

.v2-select {
  appearance: none;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='none' stroke='%2364748b' stroke-width='1.5' d='M1 1l5 5 5-5'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right var(--space-3) center;
  padding-right: var(--space-8);
  cursor: pointer;
}
</style>
